/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { ImageItemModelShape } from '@bingads-webui-react/image-picker';

const emptyButtonStyle = {
  padding: '2px',
  margin: '0px',
  background: 'none',
  color: 'unset',
  cursor: 'pointer',
  borderImage: 'unset',
  borderColor: 'unset',
  borderStyle: 'none',
};

const getInvestVideoItemWrapper = ({ onInvestVideoSelected }) => {
  const InvestVideoItemWrapper = (props) => {
    const { itemHeight, image: videoThumbnail } = props;

    const [videoText] = useState(videoThumbnail.altText);

    const thumbnailHeight = itemHeight;
    const thumbnailWidth = Math.round((videoThumbnail.width * thumbnailHeight) / videoThumbnail.height);
    const limitedThumbnailWidth =
            thumbnailWidth / thumbnailHeight > 1.6 ? thumbnailHeight * 1.6 : thumbnailWidth;

    const wrapperStyle = {
      maxHeight: thumbnailHeight,
      height: thumbnailHeight,
      width: limitedThumbnailWidth,
      position: 'relative',
      overflow: 'visible',
      margin: '5px',
    };

    return (
      <div style={wrapperStyle} className="existing-image-container">
        <div className="image-section-wrapper" style={{ overflow: 'hidden' }}>
          <div className="image-section">
            <div className="image-content-wrap" data-imageid={videoThumbnail.idString}>
              <button
                onClick={() => onInvestVideoSelected([videoThumbnail])}
                id={videoThumbnail.id}
                style={emptyButtonStyle}
                height={thumbnailHeight}
                width={limitedThumbnailWidth}
              >
                <video autoPlay={false} loop style={{ width: '100%', height: '100%' }}>
                  <source src={videoThumbnail.videoSrc} />
                </video>
              </button>
            </div>
          </div>
        </div>
        <div className="image-name-section">
          <span className="image-name" title={videoText}>
            {videoText}
          </span>
        </div>
      </div>
    );
  };

  InvestVideoItemWrapper.propTypes = {
    image: ImageItemModelShape.isRequired,
    itemHeight: PropTypes.number.isRequired,
  };

  return InvestVideoItemWrapper;
};

export default getInvestVideoItemWrapper;
